export default "__VITE_ASSET__947166bc__"